import { IMAGE_PADDING } from 'js/file_viewer/core/utils/sizing_const';
/**
 * Calculate max dimensions that fit in maxWidth/maxHeight while preserving aspectRatio.
 * @param maxWidth max width
 * @param maxHeight max height
 * @param aspectRatio aspect ratio
 */
export function calculateFitBox(maxWidth, maxHeight, aspectRatio) {
    const boxAspectRatio = maxWidth / maxHeight;
    if (isNaN(aspectRatio) ||
        isNaN(boxAspectRatio) ||
        !isFinite(boxAspectRatio) ||
        !isFinite(aspectRatio)) {
        return [0, 0];
    }
    if (boxAspectRatio > aspectRatio) {
        return [maxHeight * aspectRatio, maxHeight];
    }
    return [maxWidth, maxWidth / aspectRatio];
}
/**
 * Calculates the size of an image
 * @param imageSize Size of the image
 * @param viewport Size of the image viewport.
 * @param scaleFactor Current zoom level.
 */
export function calculateImageSizerDimensions(imageSize, viewport, scaleFactor = 1.0) {
    const width = imageSize.width * scaleFactor;
    const height = imageSize.height * scaleFactor;
    let translateX = 0;
    let translateY = 0;
    // Center horizontally & vertically accordingly if width/height is smaller than viewport.
    // The reason we have to do this is because absolute center positioning doesn't seem to work with `transform: scale`.
    if (width < viewport.width) {
        translateX = (viewport.width - width) / 2;
    }
    if (height < viewport.height) {
        translateY = (viewport.height - height) / 2;
    }
    return {
        width,
        height,
        translateX,
        translateY,
    };
}
/**
 * Returns the value of the `sizes` property on HTMLImageElement given image width and the window.
 * @param imageWidth Width of the image in pixels.
 */
export function getImageSizeScale(imageWidth) {
    return ((imageWidth / window.innerWidth) * 100) / window.devicePixelRatio;
}
/**
 * Returns the approximate size at which an image will be displayed in the File Viewer. This is suited for use
 * outside the File Viewer, in contexts that do not have access to the File Viewer's state.
 * @param dimensions The dimensions of the image.
 */
export function getApproximateImageSizeScale(imageSize) {
    const APPROXIMATE_COMBINED_TITLEBAR_TOOLBAR_HEIGHT = 132;
    const aspectRatio = imageSize.width / imageSize.height;
    // Approximate since it ignores the presence of sidebars.
    // TODO: If the optimized image experiment is successful, make this more robust by making prefetching code aware
    // of sidebar presence. As it stands, we can only really trust experiment results on logged out shared link pages,
    // where there is guaranteed to be no sidebars on first render.
    const approximateViewportWidth = window.innerWidth;
    const approximateViewportHeight = window.innerHeight - APPROXIMATE_COMBINED_TITLEBAR_TOOLBAR_HEIGHT;
    const [sizerWidth] = calculateFitBox(approximateViewportWidth - IMAGE_PADDING.horizontal, approximateViewportHeight - IMAGE_PADDING.vertical, aspectRatio);
    return getImageSizeScale(sizerWidth);
}
//# sourceMappingURL=sizing_utils.preenvesnextjs.map
